import { Search, Columns3 } from 'lucide-react';
import { TableRow, TableCell } from '@/components/ui/table';
import type { DataTableEmptyProps } from './types';

export interface DataTableEmptyExtendedProps extends DataTableEmptyProps {
  variant?: 'no-results' | 'no-columns';
  actionLabel?: string;
  onAction?: () => void;
}

export function DataTableEmpty({
  message,
  columnCount,
  variant = 'no-results',
  actionLabel,
  onAction,
}: DataTableEmptyExtendedProps) {
  const Icon = variant === 'no-columns' ? Columns3 : Search;

  return (
    <TableRow>
      <TableCell colSpan={columnCount} data-testid="empty-state-cell">
        <div
          className="flex flex-col items-center justify-center py-20 px-4 text-center text-v11-text-muted"
          data-testid="empty-state"
        >
          <div className="mb-4 p-4 rounded-full bg-v11-surface-hover">
            <Icon className="h-12 w-12 text-v11-text-muted" />
          </div>
          <h3 className="text-lg font-semibold text-v11-text-primary mb-2">
            {variant === 'no-columns' ? 'No Columns Selected' : 'No Results Found'}
          </h3>
          <p className="text-sm text-v11-text-muted max-w-md">{message}</p>
          {actionLabel && onAction && (
            <button
              onClick={onAction}
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium transition-colors"
              data-testid="empty-state-action"
            >
              {actionLabel}
            </button>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
}
